module.exports = __webpack_public_path__ + "src/assets/games/5/qiche2.png";